import React, { useState, useEffect } from "react";
import { useLanguage } from "../../../../contexts/LanguageContext"; 
import placeholderImage from "../../../../assets/images/placeholderimage.png";
import { videoSlider } from "../../../../utils/translations";
import videOne from "../../../../assets/videos/videone.mp4";
import videoTwo from "../../../../assets/videos/videotwo.mp4";
import videoThree from "../../../../assets/videos/videotwo.mp4";
import "./videoSlider.css"; 
import DownloadDropdown from "../DownloadDropdown/DownloadDropdown";

const videos = [
  videOne,
  videoTwo,
  videoThree
];

const VideoSlider = () => {
  const { language } = useLanguage(); 
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    let loadedCount = 0;

    videos.forEach((video, index) => {
      fetch(video)
        .then(res => {
          if (res.ok) {
            loadedCount++;
            console.log(`Video ${index + 1} has been loaded (${loadedCount}/${videos.length})`);
            if (loadedCount === videos.length) {
              setIsReady(true);
            }
          }
        })
        .catch(err => console.error(`Failed to load video ${index + 1}:`, err));
    });
  }, []);

  useEffect(() => {
    if (isReady) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) =>
          prevIndex === videos.length - 1 ? 0 : prevIndex + 1
        );
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [isReady]);

  return (
    <div className= {`videoSlider-container ${language === "ar" ? "arab" : ""}`}>
      <div className="videoSlider-overlay">
        <h1 className="videoSlider-title">{videoSlider[language].title1}</h1>
        <h1 className="videoSlider-title">{videoSlider[language].title2}</h1>
        <DownloadDropdown
          buttonText={videoSlider[language].button}
          telegramButtonText={videoSlider[language].telegramButton}
        />
      </div>

      {!isReady ? (
        <img src={placeholderImage} alt="Loading..." className="videoSlider-placeholderImage" />
      ) : (
        <div className="videoWrapper">
          {videos.map((video, index) => (
            <video
              key={index}
              src={video}
              className="videoSlider-video"
              style={{
                opacity: currentIndex === index ? 1 : 0, 
                transition: "opacity 1s ease",
              }}
              autoPlay
              muted
              loop
              preload="auto"
              controls={false}
            ></video>
          ))}
        </div>
      )}

      {isReady && (
        <div className="videoSlider-indicators">
          {videos.map((_, index) => (
            <div
              key={index}
              className="videoSlider-indicator"
              style={{
                width: currentIndex === index ? "50px" : "15px",
                background: currentIndex === index ? "var(--primary-color)" : "#ccc",
              }}
            ></div>
          ))}
        </div>
      )}
    </div>
  );
};

export default VideoSlider;
